import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Patients from "./pages/Patients";
import PatientNew from "./pages/PatientNew";
import PatientDetail from "./pages/PatientDetail";
import Settings from "./pages/Settings";
import Users from "./pages/Users";
import AuditLogs from "./pages/AuditLogs";
import PatientPortal from "./pages/PatientPortal";
import { Toaster } from "sonner";
import ErrorBoundary from "./components/ErrorBoundary";

const Shell = ({ children, roles }) => (
  <ProtectedRoute roles={roles}>
    <AppShell>{children}</AppShell>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<PatientPortal />} />
            <Route path="/portal/:token" element={<PatientPortal />} />
            <Route path="/dashboard" element={<Shell><Dashboard /></Shell>} />
            <Route path="/patients" element={<Shell><Patients /></Shell>} />
            <Route path="/patients/new" element={<Shell><PatientNew /></Shell>} />
            <Route path="/patients/:id" element={<Shell><PatientDetail /></Shell>} />
            <Route path="/settings" element={<Shell roles={["superadmin", "admin"]}><Settings /></Shell>} />
            <Route path="/users" element={<Shell roles={["superadmin"]}><Users /></Shell>} />
            <Route path="/audit-logs" element={<Shell roles={["superadmin", "admin"]}><AuditLogs /></Shell>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
